/**
 * --------------------------------------------------------------------------
 * Basic Modules: GridMasonry.js
 * --------------------------------------------------------------------------
 */

//import Util from "../util";

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const DEBUG             = false;
const NAME              = 'gridMasonry';
const DATA_KEY          = NAME;
const EVENT_KEY         = `.${DATA_KEY}`;
const LOG_KEY           = `[${NAME}]`;

const Default = {
    equalHeight: false,
};

const Event = {
    RESIZE              : `resize${EVENT_KEY} orientationchange${EVENT_KEY}`,
    SCROLL              : `scroll${EVENT_KEY}`,
    CLICK               : `click${EVENT_KEY}`,
};

const ClassName = {
    ACTIVE              : 'is-active',
    LOADED              : '-grid-images-loaded',
};

const Selector = {
    TOGGLE              : `[data-toggle-grid-masonry]`,
    ITEM                : '.c-grid-item',
};

const DataAttr = {
};

class GridMasonry {

    constructor(element, config) {

        DEBUG && console.log(LOG_KEY, 'Init');

        this.resizeTimeout = null;

        this._element = element;
        this._config  = this._getConfig(config);

        $(this._element).imagesLoaded(() => {
            this._setItemHeight();

            $(this._element).addClass(ClassName.LOADED);

            let $grid = $(this._element).isotope({
                itemSelector: Selector.ITEM,
                layoutMode: 'masonry',
            });
        });

        //this._addEventListeners();
    }

    destroy() {
        $(this._element).off(EVENT_KEY);
        $.removeData(this._element, DATA_KEY);
        this._element = null;
    }

    // Private

    _setItemHeight() {
        if (this._config.equalHeight) {
            $(this._element).children().css('min-height', 0);
            $(this._element).equalHeights();
        }
    }

    _reLayoutItems() {
        this._setItemHeight();
        $(this._element).isotope('layout');
    }

    _addEventListeners() {
        $(window).on(Event.RESIZE, (event) => this._handleWindowResize(event));
    }

    /**
     * Handle the resizing of the window
     * @private
     */
    _handleWindowResize() {

        if (this.resizeTimeout) return;

        // do stuff here when window is resized.
            this._reLayoutItems();
        // .end

        this.resizeTimeout = setTimeout(() => {
            this.resizeTimeout = null;
        }, 500);
    }

    _getConfig(config) {
        return {
            ...Default,
            ...config
        };
    }

    // Static

    /**
     * Convenient static method to initiate the module.
     *
     * @param config
     * @param selector
     */
    static bind (config, selector) {
        GridMasonry._jQueryInterface.call($(selector || Selector.TOGGLE), config);
    }

    /**
     * jQuery Interface
     * @param config
     * @returns {*}
     */
    static _jQueryInterface(config) {
        return this.each(function() {
            const $this = $(this);
            let data    = $this.data(DATA_KEY);
            let _config = {
                ...Default,
                ...$this.data(),
                ...typeof config === 'object' && config ? config : {}
            };

            if (!data) {
                data = new GridMasonry(this, _config);
                $this.data(DATA_KEY, data);
            }

            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') {
                    throw new TypeError(`No method named "${config}"`);
                }
                data[config]();
            }
        });
    }
}

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn[NAME] = GridMasonry._jQueryInterface;
$.fn[NAME].Constructor = GridMasonry;


export default GridMasonry;
